const steps = [
  { num: '01', title: 'Предварительный анализ', desc: 'Определяем, какие проблемы необходимо решить через наставничество и развитие сотрудников.' },
  { num: '02', title: 'Диагностика', desc: 'Изучаем уровень участников и реальные рабочие ситуации.' },
  { num: '03', title: 'Подготовка программы', desc: 'Адаптируем содержание под компанию.' },
  { num: '04', title: 'Практическое обучение', desc: 'Разбираем инструменты и отрабатываем их.' },
  { num: '05', title: 'Внедрение', desc: 'Участники используют инструменты в реальной работе.' },
  { num: '06', title: 'Обратная связь', desc: 'Разбираем результаты и корректируем подходы.' },
  { num: '07', title: 'Сопровождение', desc: 'При необходимости продолжаем работу после обучения.' },
];

export default function HowTrainingGoes() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как проходит обучение
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          От задачи компании до внедрения — последовательность, которая обеспечивает перенос навыков наставничества в реальную практику
        </p>

        <div className="relative">
          <div className="hidden lg:block absolute left-[23px] top-8 bottom-8 w-0.5 bg-teal-200"></div>
          <div className="space-y-5">
            {steps.map((step) => (
              <div key={step.num} className="flex gap-5 items-start relative">
                <div className="w-12 h-12 rounded-full bg-teal-600 text-white flex items-center justify-center text-sm font-bold flex-shrink-0 z-10">
                  {step.num}
                </div>
                <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 flex-1 hover:border-teal-300 transition-colors">
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5">{step.title}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}